import {Component, TemplateRef, ViewChild} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {FormsModule} from '@angular/forms';
import {NgClass, NgForOf, NgIf} from '@angular/common';


export interface TextInputModalConfig {
    title: string;
    placeholder?: string;
    initialValue?: string;
    confirmText?: string;
    cancelText?: string;
    showCancelButton?: boolean;
    confirmButtonClass?: string;
    isTextArea?: boolean;
    textAreaRows?: number;
    maxLength?: number;
    required?: boolean;
    onConfirm?: (value: string) => void;
    onCancel?: () => void;
    inputType?: string;
    validationErrors?: string[];
    showValidationErrors?: boolean;
}

@Component({
    selector: 'eil-text-input-modal',
    templateUrl: './text-input-modal.component.html',
    styleUrls: ['./text-input-modal.component.scss'],
    imports: [
        FormsModule,
        NgClass,
        NgIf,
        NgForOf
    ],
    standalone: true
})
export class TextInputModalComponent {
    @ViewChild('textInputModalTemplate', {static: true})
    textInputModalTemplateRef: TemplateRef<any>;

    title: string = '';
    placeholder: string = '';
    inputValue: string = '';
    confirmText: string = 'OK';
    cancelText: string = 'Cancel';
    showCancelButton: boolean = true;
    confirmButtonClass: string = 'btn btn-primary';
    isTextArea: boolean = false;
    textAreaRows: number = 4;
    maxLength?: number;
    required: boolean = false;
    inputId: string = '';
    inputType: string = 'text';
    validationErrors: string[] = [];
    showValidationErrors: boolean = false;


    private modalRef: BsModalRef;
    private config: TextInputModalConfig;

    constructor(private modalService: BsModalService) {
        this.inputId = 'text-input-' + Math.random().toString(36).substring(2, 11);
    }

    show(config: TextInputModalConfig): BsModalRef {
        this.config = config;
        this.title = config.title;
        this.placeholder = config.placeholder ?? '';
        this.inputValue = config.initialValue ?? '';
        this.confirmText = config.confirmText ?? 'OK';
        this.cancelText = config.cancelText ?? 'Cancel';
        this.showCancelButton = config.showCancelButton ?? true;
        this.confirmButtonClass = config.confirmButtonClass ?? 'btn btn-primary';
        this.isTextArea = config.isTextArea ?? false;
        this.textAreaRows = config.textAreaRows ?? 4;
        this.maxLength = config.maxLength;
        this.required = config.required ?? false;
        this.inputType = config.inputType ?? 'text';
        this.validationErrors = config.validationErrors ?? [];
        this.showValidationErrors = config.showValidationErrors ?? false;

        const modalConfig = {
            backdrop: true,
            ignoreBackdropClick: true,
        };

        this.modalRef = this.modalService.show(this.textInputModalTemplateRef, modalConfig);
        return this.modalRef;
    }

    updateValidationErrors(errors: string[]): void {
        this.validationErrors = errors;
        this.showValidationErrors = errors.length > 0;
    }

    hide(): void {
        if (this.modalRef) {
            this.modalRef.hide();
        }
    }

    // We do not always want to hide the modal on confirm, so we leave that decision to the caller
    // Imagine a scenario where the input is invalid and we want to show validation errors without closing the modal
    onConfirm(): void {
        if (this.config?.onConfirm) {
            this.config.onConfirm(this.inputValue);
        }
    }

    onCancel(): void {
        if (this.config?.onCancel) {
            this.config.onCancel();
        }
        this.hide();
    }
}
